import '../../elements/pro_link/pro_link'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { currentDevice } from '../../core/utils/currentDevice'
import { getIsUserScrolling } from '../../core/utils/userScrollDetection'
import { FASTBOOKING_EVENTS } from '../../shared/fastbooking/constants'
import fastbooking from '../../shared/fastbooking/ibh_fastbooking'
import { refreshUserLoggedTooltip } from '../../shared/ihg_tooltips/ihg_tooltip'
import isInViewport from '../../utils/isInViewport'

import { initializeUtagEvents } from './header.analytics'

dayjs.extend(customParseFormat)

const lang = document.documentElement.getAttribute('data-js-lang')
const format = 'YYYY-MM-DD'

/**
 * Main selectors
 */
const mainHeader = document.querySelector('.js-main-header')
const headerPanel = mainHeader?.querySelector('.js-main-header-panel') // Panel

/**
 * Selector for the menu toggle
 */
const menuToggle = document.querySelector('.js-vue-menu-toggle')

/**
 * Navbar
 */
const navBar = mainHeader?.querySelector('.js-main-header-content')
/**
 * Placeholder to move fastbooking to the header
 */
const fastbookingInputFake = navBar?.querySelector('.js-fb-fake-input')

function moveFastBookingSticky() {
  const fastbookingContainer = document.querySelector('.js-ibh-fastbooking-container')
  const fastbookingTabs = fastbookingContainer.querySelector('.js-ibh-fastbooking-tabs')
  const panelHeaderTabsContainer = headerPanel?.querySelector('.js-main-header-tabs')
  const panelBody = headerPanel?.querySelector('.js-main-header-panel-body')
  fastbookingTabs && panelHeaderTabsContainer.appendChild(fastbookingTabs)
  panelBody.appendChild(fastbookingContainer)
  if (fastbookingContainer.classList.contains('is-hidden')) {
    fastbookingContainer.classList.remove('is-hidden')
  }
}

function restoreFastBookingSticky() {
  const fastBookingtopLevelWrapper = document.querySelector('#ibh-fastbooking')
  const fastbookingWrapper = document.querySelector('.js-ibh-fastbooking-wrapper')
  const fastbookingContainer = document.querySelector('.js-ibh-fastbooking-container')

  if (!fastbookingContainer) return

  const panelHeaderTabsContainer = headerPanel?.querySelector('.js-main-header-tabs')
  const fastbookingTabs = panelHeaderTabsContainer.querySelector('.js-ibh-fastbooking-tabs')
  fastbookingTabs && fastbookingWrapper?.appendChild(fastbookingTabs)
  fastBookingtopLevelWrapper?.appendChild(fastbookingContainer)

  if (
    fastbookingContainer.classList.contains('js-keep-hidden') &&
    !fastbookingContainer.classList.contains('is-hidden')
  ) {
    fastbookingContainer.classList.add('is-hidden')
  }
}

function openPanel() {
  headerPanel.classList.remove('is-hidden')
  mainHeader.querySelector('.js-main-header-hotel-nav')?.classList.add('is-hidden')
  if (isInViewport(mainHeader)) {
    // If header is visible, move fastbooking to the header
    moveFastBookingSticky()
  }
}

function setFastbookingFakeVisibility() {
  const fakeFb = navBar?.querySelector('.js-main-header-fake')

  if (fastbooking.isInitialized && fakeFb) {
    fakeFb.classList.remove('is-hidden')
  }
}

function initClickOpenPanel() {
  const fakeInput = navBar?.querySelector('.js-main-header-fake .js-fb-fake-input')
  const button = navBar?.querySelector('.js-main-header-fake .js-fb-button')

  ;[button, fakeInput].forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault()
      openPanel()
    })
  })
}

export function closePanel() {
  headerPanel.classList.add('is-hidden')
  mainHeader.querySelector('.js-main-header-hotel-nav')?.classList.remove('is-hidden')
  restoreFastBookingSticky()
  fastbooking.closePanels()
}

function initClickClosePanel() {
  const iconClosePanel = headerPanel?.querySelector('.close-panel')
  iconClosePanel.addEventListener('click', closePanel)
}

function placeholderLastSearch() {
  // Capture event
  document.addEventListener(FASTBOOKING_EVENTS.STATE_UPDATED, () => {
    if (fastbooking.state.place_to_go) {
      if (fastbooking.state.dates) {
        const checkIn = dayjs(fastbooking.state?.dates?.check_in, format).format('D MMM') // D-M numeric format
        // Check if there is no Check_out. If there is, add separator
        const checkOut = fastbooking.state.dates.check_out
          ? `- ${dayjs(fastbooking.state?.dates?.check_out, format).format('D MMM')}`
          : '' // D-M numeric format
        fastbookingInputFake.innerHTML = `${fastbooking.state.place_to_go.name} <span></span> ${checkIn} ${checkOut}`
      } else {
        fastbookingInputFake.innerHTML = `${fastbooking.state.place_to_go.name}`
      }
    } else {
      fastbookingInputFake.textContent = fastbookingInputFake.getAttribute('data-initial-message')
    }
  })
}
function offsetHeadbandSticky() {
  const stickyHeadband = document.querySelector('.js-headband.sticky.slide-down')
  if (!stickyHeadband) return

  const occupiedHeight = stickyHeadband.clientHeight - 2
  document.body.style.paddingTop = `${occupiedHeight}px`
}

function toggleMenu() {
  const menu = mainHeader?.querySelector('.js-main-header-menu')

  menuToggle.classList.toggle('close')
  menu.classList.toggle('is-hidden')

  const isHidden = menu.classList.contains('is-hidden')

  mainHeader.style.transform = ''

  if (fastbooking.isInitialized) {
    const fakeInputHeader = navBar?.querySelector('.js-main-header-fake')
    fakeInputHeader?.classList.toggle('is-hidden')
  }

  isHidden ? ScrollLock.off(true) : ScrollLock.on(true)

  if (fastbooking?.isInitialized) {
    const fakeInputHeader = navBar?.querySelector('.js-main-header-fake')

    if (fakeInputHeader) {
      fakeInputHeader.classList.toggle('is-hidden')
    }
  }

  if (menu.classList.contains('is-hidden')) {
    ScrollLock.off(true)
    offsetHeadbandSticky()
  } else {
    ScrollLock.on(true)
    offsetHeadbandSticky()
  }
}

function showContent() {
  moveFastBookingSticky()
}

function hideContent() {
  closePanel()
}

function copyInternalNav(internalNav) {
  const hotelNav = document.querySelector('.js-main-header-hotel-nav')
  const fakeItems = hotelNav.querySelectorAll('.menu_item')

  internalNav.classList.add('internal-nav__hidden')

  internalNav.querySelector('.js-internal-nav-list').prepend(...fakeItems)
  fakeItems.forEach(item => {
    item.classList.remove('hidden')
  })

  hotelNav.append(internalNav)
  setTimeout(() => {
    internalNav.classList.remove('internal-nav__hidden')
  }, 100)
}

function showStickyHeader() {
  if (!mainHeader.classList.contains('sticky')) {
    mainHeader.classList.add('sticky')
  }
}

function hideStickyHeader() {
  if (mainHeader.classList.contains('sticky')) {
    mainHeader.classList.remove('sticky')
  }
}

// User scroll detection
let lastScrollPosition = window.scrollY
let hasInitializedScroll = false

function handlerScroll() {
  if (hasInitializedScroll) return
  hasInitializedScroll = true

  const header = document.querySelector('.home-megabanner-slider__slider, .js-hotel-main-header, .js-header-customized')
  const headerBottomLimit = 0

  if (!header) return

  document.addEventListener('scroll', () => {
    const isUserScrolling = getIsUserScrolling()
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    const scrollDifference = Math.abs(currentScrollPosition - lastScrollPosition)

    lastScrollPosition = currentScrollPosition

    if (scrollDifference <= 5) return

    const scroll = window.scrollY
    const headerHeight = header?.offsetHeight ?? 0
    const headerBottom = headerHeight - scroll
    if (headerBottom <= headerBottomLimit) {
      showStickyHeader()
    } else if (isUserScrolling) {
      // Difference between user scroll and programmatic scroll
      hideStickyHeader()
      closePanel()
    }
  })
}

function init() {
  if (!mainHeader) return

  mainHeader.classList.remove('hidden')

  import('../../vue/main_nav/vue_main_nav').then(mainNav => {
    mainNav.default.init()
  })

  handlerScroll()

  initClickOpenPanel()
  initClickClosePanel()

  import(`dayjs/locale/${lang}.js`).then(() => {
    dayjs.locale(lang)
    placeholderLastSearch()
  })

  menuToggle.addEventListener('click', e => {
    e.preventDefault()
    toggleMenu()
  })

  setFastbookingFakeVisibility()
  fastbooking.on(FASTBOOKING_EVENTS.FASTBOOKING_READY, () => {
    setFastbookingFakeVisibility()
  })

  // Refresh ihg user logged position if present
  refreshUserLoggedTooltip()
}

const MainHeader = {
  init,
  showContent,
  hideContent,
  openPanel,
  restoreFastBookingSticky,
  copyInternalNav,
}

document.addEventListener('DOMContentLoaded', function () {
  if (currentDevice.isDesktop) {
    MainHeader.init()
  }
  initializeUtagEvents()
})

export default MainHeader
